import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  bannnerData: {},
  isLoading: false,
  error: "",
  hasData: false
};
const fetchDestinationSlice = createSlice({
  name: "destinationList",
  initialState,
  reducers: {
    getDestinationBannerRequest: state => {
      state.isLoading = true;
    },
    getDestinationBannerSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.bannnerData = action?.payload;
    },
    getDestinationBannerFailure: (state, action) => {
      state.isLoading = false;
      state.hasData = false;
      state.error = action?.payload?.response?.data;
      state.bannnerData = {};
    }
  }
});
export const {
  getDestinationBannerRequest,
  getDestinationBannerSuccess,
  getDestinationBannerFailure
} = fetchDestinationSlice.actions;
export default fetchDestinationSlice.reducer;